import { GuestUpdateType, PlaydateInvite } from "../../gql/types";
import { TagVariant } from "./InfoTag";

export const inboundTopLeftLabelComputer = (invite: PlaydateInvite): Array<{ label: string; variant: TagVariant }> => {
    const topLeftTags: Array<{ label: string; variant: TagVariant }> = [];

    if (invite.guestUpdate) {
        switch (invite.guestUpdate.updateType) {
            case GuestUpdateType.InviteModified:
                topLeftTags.push({
                    label: "Details Changed",
                    variant: TagVariant.NOTICE,
                });
                break;
            // Handle in Response Status Tag
            case GuestUpdateType.ResponseRequested:
            case GuestUpdateType.InviteCreated:
            case GuestUpdateType.ResponseRecorded:
            case GuestUpdateType.ResponseRejected:
            // Handled in Status Tags
            case GuestUpdateType.InviteCancelled:
            case GuestUpdateType.Finalized:
                break;
        }
    }

    return topLeftTags;
}